import React from 'react'

export default function Heading({h1, h2, h3, h4, h5, h6, children, responsive = false, className = '', ...attrs}) {
    const Tag = h1 ? 'h1' : h2 ? 'h2' : h3 ? 'h3' : h4 ? 'h4' : h5 ? 'h5' : h6 ? 'h6' : 'h3'

    return <Tag className={`${responsive ? 'responsive' : ''}${className ? ` ${className}` : ''}`} {...attrs}>
        { children }
    </Tag>
}
